import { Map, List, fromJS } from 'immutable';
import { normalize, schema } from 'normalizr';
import * as common from 'libs/commonFunc';

// --------------------- 공통: payload 저장 표준 형태 ---------------------
export const payloadDataSaver = (state, storeKey, data) => {
  if (typeof storeKey === 'undefined') {
    storeKey = 'data';
  }
  if (typeof data === 'undefined') {
    data = {};
  }

  let stateObj = state;
  let result = -1;

  if (!data.error && data.list && Array.isArray(data.list)) {
    stateObj = stateObj.setIn([storeKey, 'success'], fromJS(data.list));
    result = 1;
  } else if (data.error && Array.isArray(data.error)) {
    stateObj = stateObj.setIn([storeKey, 'fail'], fromJS(data.error));
    result = 0;
  } else {
    result = 0;
  }

  return stateObj.setIn([storeKey, 'result'], result);
};

// --------------------- 공통: data.list 에 대한 indexByNo ---------------------
export const listIndexByNo = (d, noKey) => {
  const normalizedData = {};

  if (d && Array.isArray(d)) {
    for (let i = 0, l = d.length; i < l; i++) {
      if (typeof d[i][noKey] === 'undefined') {
        continue;
      }
      normalizedData[d[i][noKey]] = i;
    }

    if (d.length !== Object.keys(normalizedData).length) {
      return {};
    }
  }
  return normalizedData;
};

// --------------------- 관리자 (admin) Normalize ---------------------

// const parameterSchema = new schema.Entity('parameter', undefined, {
//   idAttribute: 'parameter'
// });

export const systemConfigData = data => {
  const normalizedData = { parameter: {}, class: {}, classOrder: [] };

  const parameterOrder = common.getFollowOrderArray(data, 'parameter', 'followOrder');

  const seenClass = {};
  for (let i = 0; i < parameterOrder.length; i++) {
    if (typeof data[parameterOrder[i]] === 'undefined') {
      continue;
    }
    const config = data[parameterOrder[i]];

    // redux-form 초기 값
    // normalizedData.initValue[config.parameter] = config.value || config.defaultValue;

    normalizedData.parameter[config.parameter] = config;
    normalizedData.parameter[config.parameter].beforeValue = config.value;
    if (config.paramType !== 0) {
      if (typeof seenClass[config.class] === 'undefined') {
        normalizedData.classOrder.push(config.class);
        normalizedData.class[config.class] = [];
        seenClass[config.class] = 1;
      }
      normalizedData.class[config.class].push({
        parameter: config.parameter,
        parameterNotice: config.parameterNotice,
        followOrder: config.followOrder,
        paramType: config.paramType
      });
    } else {
      // 메일 서버 테스트 파라메터
    }
  }

  return normalizedData;
};

// export const systemConfigAllData = data => {
//   const normalizedData = { parameter: {}, category: {} };

//   for (let i = 0; i < data.length; i++) {
//     const config = data[i];

//     normalizedData.parameter[config.parameter] = config;
//     if (config.paramType !== 0) {
//       if (typeof normalizedData.category[config.category] === 'undefined') {
//         normalizedData.category[config.category] = {};
//       }
//       if (typeof normalizedData.category[config.category][config.class] === 'undefined') {
//         normalizedData.category[config.category][config.class] = {};
//       }
//       normalizedData.category[config.category][config.class][config.parameter] = {
//         followOrder: config.followOrder,
//         paramType: config.paramType
//       };
//     }
//   }

//   return normalizedData;
// };

// export const __systemConfigDataTemp = (data, type) => {
//   const schema = [parameterSchema];
//   const normalizedData = normalize(data, schema);

//   if (type === 1) {
//     return normalizedData.entities;
//   }

//   return normalizedData;
// };

// --------------------- 훈련 템플릿(template) Normalize ---------------------
export const examTemplateIndexByNo = d => {
  const normalizedData = {};

  if (d && Array.isArray(d)) {
    for (let i = 0, l = d.length; i < l; i++) {
      if (typeof d[i].templateNo === 'undefined' || typeof d[i].serviceTemplateNo === 'undefined') {
        continue;
      }
      normalizedData[d[i].templateNo + '+' + d[i].serviceTemplateNo] = i;
    }

    if (d.length !== Object.keys(normalizedData).length) {
      return {};
    }
  }

  return normalizedData;
};

// --------------------- 훈련 목록(exam) Normalize ---------------------

// 검토해서 다시 만들 것... 현재는 안씀. 결과보기 왼쪽 훈련 목록에서 사용하게 될 것
const parameterSchema = new schema.Entity('parameter', undefined, {
  idAttribute: 'parameter'
});

export const examData = (data, type) => {
  const normalizedData = { templateList: {}, tagList: {}, targetList: {} };

  for (let i = 0; i < data.length; i++) {
    if (!data[i]['targetNo'] && !data[i]['tagNo']) {
      normalizedData['templateList'] = JSON.parse(data[i]['name']);
    } else if (!data[i]['targetNo']) {
      normalizedData['targetList'][data[i]['name']] = data[i]['targetNo'];
    } else {
      normalizedData['tagList'][data[i]['name']] = data[i]['tagNo'];
    }
  }

  return normalizedData;
};

// --------------------- 태그 (tag) Normalize ---------------------
export const tagNormalize = (data, type) => {
  let normalizedData = {};

  for (let i = 0, l = data.length; i < l; i++) {
    // 기본 색상
    if (!data[i].color) {
      data[i].color = 'red';
    }

    // tagNo를 key로 정렬
    if (type === 'tagNo') {
      normalizedData[data[i].tagNo] = data[i];
      // 이니셜을 key 정렬
    } else {
      const initData = data[i].tagInitial;
      if (typeof normalizedData[initData] === 'undefined') {
        normalizedData[initData] = { tagItemList: [], isView: true };
      }

      normalizedData[initData].tagItemList.push(data[i]);
    }
  }

  if (type === 'initialOrdering') {
    return Object.keys(normalizedData).sort();
  }

  // 정렬 처리
  normalizedData = common.sortObjectByKey(normalizedData);

  return normalizedData;
};

// --------------------- 대상자 (target) Normalize ---------------------
export const targetNormalize = list => {
  let normalizedData = {};

  for (let i = 0, l = list.length; i < l; i++) {
    normalizedData[list[i].targetNo] = list[i];
  }

  // 정렬 처리
  normalizedData = common.sortObjectByKey(normalizedData);

  return normalizedData;
};

export const targetArrayNormalize = list => {
  const arrayData = [];

  for (let i = 0, l = list.length; i < l; i++) {
    // targetNo key로 정렬
    arrayData.push(list[i].targetNo);
  }

  return arrayData;
};

// --------------------- 훈련 요약(목록) (examSummary) Normalize ---------------------
export const examNormalize = list => {
  let normalizedData = {};

  for (let i = 0, l = list.length; i < l; i++) {
    normalizedData[list[i].examNo] = list[i];
  }

  // 정렬 처리
  normalizedData = common.sortObjectByKey(normalizedData);

  return normalizedData;
};

export const examArrayNormalize = list => {
  const arrayData = [];

  for (let i = 0, l = list.length; i < l; i++) {
    // examNo key로 정렬
    arrayData.push(list[i].examNo);
  }

  return arrayData;
};

// --------------------- 훈련 목록 (examList) Normalize ---------------------
export const examListNormalize = (list, noType) => {
  let normalizedData = {};

  for (let i = 0, l = list.length; i < l; i++) {
    normalizedData[list[i][noType]] = list[i];
  }

  // 정렬 처리
  normalizedData = common.sortObjectByKey(normalizedData);

  return normalizedData;
};

export const examListArrayNormalize = (list, noType) => {
  const arrayData = [];

  for (let i = 0, l = list.length; i < l; i++) {
    // examNo key로 정렬
    arrayData.push(list[i][noType]);
  }

  return arrayData;
};

// --------------------- 신고하기 대상자 (Declare/External) Normalize ---------------------
export const declareNormalize = list => {
  let normalizedData = {};

  for (let i = 0, l = list.length; i < l; i++) {
    normalizedData[list[i].declareNo] = list[i];
  }

  // 정렬 처리
  normalizedData = common.sortObjectByKey(normalizedData);

  return normalizedData;
};

export const declareArrayNormalize = list => {
  const arrayData = [];

  for (let i = 0, l = list.length; i < l; i++) {
    // targetNo key로 정렬
    arrayData.push(list[i].declareNo);
  }

  return arrayData;
};


// WEBPACK FOOTER //
// ./src/script/libs/normalizer.js